import * as Actions from '../../../redux/actions'

import DestinationsFilter from './DestinationsFilter'
import Fab from '@material-ui/core/Fab'
import FeatureListContainer from "./FeatureListContainer"
import { MapDuotoneIcon } from "../Common/SVGBank"
import React from 'react'
import Features from './Features'
import { SearchBar } from "./SearchBar"
import { SortingBar } from "./SortingBar"
import SubTypes from "./SubTypes"
import TopBarSlider from './TopBarSlider'
import Types from './Types'
import { connect } from 'react-redux'
import { features_router, list_container_mode, types_router } from '../Common/RegExValidate'
import { useState } from 'react';
import Breadcrumb from './Breadcrumb';
import DestinationTopBarSlider from '../DestinationPage/TopBarSlider';
import { capitalizeWord } from '../../../utility/utility'
import { Link, makeStyles, Modal } from '@material-ui/core'
import { PersonalizedTripComponent } from './personalizedTrip/personalizedTrip'
import { useDispatch } from 'react-redux'
import { toggleModal } from './personalizedTrip/personalizedTrip.slice'
import { SubDestinations } from './Subdestinations'
import { getSubDestinations } from './Destination.slice'
import { useHistory } from 'react-router-dom';
import Header from '../Header/Header'
import { HeaderMobile } from '../Header/HeaderMobile'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRoute } from '@fortawesome/free-solid-svg-icons'
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import HotelSearchFormEmbedded from '../Common/BookingForm/HotelSearchFormEmbedded'
import "../MuverPage/MuverPage.css"
import { environment } from '../../../Environments/environment'
import AiChatBox from '../Common/AiChatBox/AiChatBox'

const FeatureContainer_ = ({ activeFeatureId, subDestinations, activeTrip, selectedTypes, authModal, featureList, subtypes, preload, ActiveTrip, activeId, props, lang, is_mobile, app_menu_height, timelineStatus,
    setTripDisplayMode, setPageYOffset, setFeaturePage, addSelectedDestinationsFeature, selectedDestinations }) => {
    const [isDestination, setIsDestination] = useState(false)
    const featureID = props.match.params.featureID
    const destinationID = props.match.params.destinationID
    const dispatch = useDispatch()
    const isAboutPage = props?.match?.params?.desc === "about" || false;
    const isPlacesPage = props?.match?.params?.desc === "places" || false;
    const [showAddPrompt, setAddPrompt] = useState(false)
    const theme = useTheme();
    const xSmallScreen = useMediaQuery(theme.breakpoints.only('xs'));
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const medScreen = useMediaQuery(theme.breakpoints.only('md'));
    const lgScreen = useMediaQuery(theme.breakpoints.only('lg'));
    const xlScreen = useMediaQuery(theme.breakpoints.only('xl'));
    const localShowAddTrip = localStorage.getItem("showAddtrip");

    const setDestinationPage = () => {
        if (destinationID !== undefined &&
            destinationID !== null &&
            destinationID !== "") {
            setIsDestination(true);
            addSelectedDestinationsFeature(destinationID, [])  //filters page by id
            dispatch(getSubDestinations(destinationID))
        }
    }

    const history = useHistory()

    const goToAboutPage = () => {
        const url = "/destination/about/1/" + activeId;
        history.push(url.toLowerCase())
    }

    React.useEffect(() => {
        setDestinationPage()  //use as destination page
    }, [props.match.params])


    React.useEffect(() => {
        if (!localShowAddTrip && timelineStatus) {
            localStorage.setItem("showAddtrip", "true");
            setAddPrompt(true)
        }
        else {
            setAddPrompt(false)
        }
    }, [activeTrip.addedActivityID, timelineStatus])

    React.useEffect(() => {
        // const hasSeeType = subtypes.find((type) => type.id === "1");
        // if (!hasSeeType && !preload && featureID === "1" && !isAboutPage) {
        //     goToAboutPage() ///force about page
        // }
        if ((!subtypes || !(subtypes?.length > 0)) && !preload && !isAboutPage && !featureID) {
            goToAboutPage() ///force about page
        }

    }, [subtypes])
    let padding_l = 15
    let padding_r = 15


    const isLoggedIn = () => {
        return authModal?.uuid && authModal?.uuid.length > 0 ? true : false
    }

    if (!isNaN(is_mobile)) {
        padding_l = is_mobile ? "8.5" : (timelineStatus ? lgScreen ? '36' : "31" : "15")
        padding_r = is_mobile ? "8.5" : (timelineStatus ? "13" : "15")
    }
    const handleMap = () => {
        setTripDisplayMode(list_container_mode.map)
        setPageYOffset(0)
    }

    const isStayType = selectedTypes?.length > 0 ? selectedTypes?.find((type) => type?.typeID === "4") : null





    return (
        <div style={{ position: "relative" }}>
            {!is_mobile ? null : <HeaderMobile useTransparent bg_color={"transparent"} text_color={"var(--mainBlack)"}
            />}

            {!isDestination && <TopBarSlider />}
            {isDestination && <DestinationTopBarSlider />}
            {isDestination && <Breadcrumb />}
            {isDestination && subDestinations && subDestinations?.length > 0 &&
                <div style={{
                    paddingTop: "10px",
                    marginLeft: padding_l + "%",
                    paddingRight: padding_r + "%",
                    paddingBottom: "10px",
                }}>
                    <SubDestinations />
                </div>}

            <div style={{
                paddingTop: "10px",
                marginLeft: padding_l + "%",
                paddingRight: padding_r + "%",
                paddingBottom: "10px",
                position: is_mobile ? "relative" : "sticky",
                top: is_mobile ? "0px" : (Math.ceil(app_menu_height / 2)) + "px",
                backgroundColor: smallScreen ? "var(--frameBlack)" : "#FFFFFF",
                zIndex: "3",
            }}>
                {isDestination &&
                    <div>
                        <Features lang={lang} setFeaturePage={setFeaturePage} isAboutPage={isAboutPage} />
                        <PersonalizedTripComponent />
                    </div>}

                {!isAboutPage && <Types isDestinationPage={isDestination} />}
                {!isDestination && <DestinationsFilter />}
                {isDestination && isStayType &&
                    <div className="background-img-row">
                        <div className={"margin_top_10 booking_form_container"}>
                            {<HotelSearchFormEmbedded embedForm="results" />}
                        </div>  </div>}
                <div className="d-flex margin_top_10">
                    {!isAboutPage && <SubTypes />}
                    {!is_mobile && !isAboutPage && <SearchBar isDestination={isDestination} />}
                    {!is_mobile && !isAboutPage && <SortingBar />}
                </div>
                {is_mobile && !isAboutPage && <div style={{ paddingLeft: "15px", paddingRight: "15px" }}><SearchBar isDestination={isDestination} /></div>}
                {is_mobile && !isAboutPage && <div style={{ paddingLeft: "15px", paddingRight: "15px" }}><SortingBar /></div>}



            </div>

            <div style={{
                paddingLeft: padding_l + "%",
                paddingRight: padding_r + "%",
                paddingBottom: "10px",
            }}>
                <FeatureListContainer isAboutPage={isAboutPage} />
            </div>

            {showAddPrompt && <div style={{ color: "white", font: "14px/16px Futura Md BT", padding: "15px 10px", paddingLeft: padding_l + "%", position: "fixed", width: "100%", bottom: 0, background: "#D74F3A", zIndex: "3" }}>
                Click on add to trip to add an attraction or activity to the timeline on the left. {!isLoggedIn() && <span> Login or register to save this trip and access it later in your member area.</span>}
            </div>}

            {isDestination && !is_mobile && <div style={{ position: "fixed", top: "50%", right: "100px", zIndex: "3" }}>




                {activeFeatureId === features_router.places.featureId && <Fab size="large" aria-label="back to list" style={{
                    outline: "0px",
                    backgroundColor: "#F8F8F8",
                }} onClick={() => handleMap()}>
                    <MapDuotoneIcon width={30} height={30} fill={"#0D3A7D"} style={{ marginLeft: "3px" }} />
                </Fab>}
            </div>}


        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        lang: state.Setting.lang,
        subDestinations: state.DestinationSlice.subDestinations,
        is_mobile: state.Setting.is_mobile,
        app_menu_height: state.Setting.appMenu.app_menu_height,
        timelineStatus: state.FormBank.TimelineWizard.status,
        feature: state.Feature.feature,
        subtypes: state.Feature.feature.subtypes,
        authModal: state.Member.authModal,
        selectedTypes: state.Feature.feature.loading.selectedTypes,
        selectedSubtypes: state.Feature.feature.loading.selectedSubtypes,
        selectedDestinations: state.Feature.feature.loading.selectedDestinations,
        ActiveTrip: state.ActiveTrip,
        activeFeatureId: state.Feature.feature.activeId,
        activeTrip: state.FormBank.TimelineWizard.activeTrip,
        featureList: state.Feature.feature.featureList,
        activeId: state.Destination.destination.activeId,
        preload: state.Setting.preload,
    }
}


const mapDispatchToProps = {
    setTripDisplayMode: Actions.setTripDisplayMode,
    setPageYOffset: Actions.setPageYOffset,
    addSelectedDestinationsFeature: Actions.addSelectedDestinationsFeature,
}


const FeatureContainer = connect(mapStateToProps, mapDispatchToProps)(FeatureContainer_)
export default FeatureContainer
